module.exports = __webpack_public_path__ + "img/figure-2.edac4f26.png";